define(["require", "exports", "tslib", "@arcgis/core/symbols/SimpleFillSymbol", "@arcgis/core/symbols/SimpleLineSymbol", "@arcgis/core/symbols/SimpleMarkerSymbol", "./ColourUtil", "./SpatialReferenceFactory"], function (require, exports, tslib_1, SimpleFillSymbol_1, SimpleLineSymbol_1, SimpleMarkerSymbol_1, ColourUtil_1, SpatialReferenceFactory_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.scaleWithinRange = exports.EDIT_POINT_SYMBOL = exports.EDIT_POLYGON_SYMBOL = exports.EDIT_POLYLINE_SYMBOL = exports.EDIT_SNAP_DISTANCE = exports.SNAPPING_MAX_SCALE = exports.SNAPPING_MIN_SCALE = exports.graphicsToGeometryArray = void 0;
    SimpleFillSymbol_1 = tslib_1.__importDefault(SimpleFillSymbol_1);
    SimpleLineSymbol_1 = tslib_1.__importDefault(SimpleLineSymbol_1);
    SimpleMarkerSymbol_1 = tslib_1.__importDefault(SimpleMarkerSymbol_1);
    function graphicsToGeometryArray(layer) {
        return layer.graphics.toArray().map(g => {
            g.geometry.spatialReference = SpatialReferenceFactory_1.SpatialReferenceFactory.GDA_1994;
            return g.geometry;
        });
    }
    exports.graphicsToGeometryArray = graphicsToGeometryArray;
    exports.SNAPPING_MIN_SCALE = 100000;
    exports.SNAPPING_MAX_SCALE = 10000;
    exports.EDIT_SNAP_DISTANCE = 30;
    exports.EDIT_POLYLINE_SYMBOL = new SimpleLineSymbol_1.default({
        style: "solid",
        color: ColourUtil_1.ColourUtil.PrimaryActive,
        width: 1.5
    });
    exports.EDIT_POLYGON_SYMBOL = new SimpleFillSymbol_1.default({
        style: "solid",
        outline: exports.EDIT_POLYLINE_SYMBOL,
        color: ColourUtil_1.ColourUtil.make(ColourUtil_1.ColourUtil.PrimaryActive, 0.4)
    });
    exports.EDIT_POINT_SYMBOL = new SimpleMarkerSymbol_1.default({
        style: "circle",
        size: 20,
        outline: exports.EDIT_POLYLINE_SYMBOL,
        color: ColourUtil_1.ColourUtil.make(ColourUtil_1.ColourUtil.PrimaryActive, 0.4)
    });
    function scaleWithinRange(scale, min, max) {
        return scale >= max && scale <= min;
    }
    exports.scaleWithinRange = scaleWithinRange;
});
